import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import 'jquery-serializejson';
import 'jquery-validation';
import {DebtsService} from '../../../models/debts/debts.service';

@Component({
    selector: 'void-modal',
    templateUrl: 'void-modal.template.html',
    styleUrls: []
})

export class VoidModalComponent implements OnInit, AfterViewInit {

    @Input()
    public transaction = <any> {};

    public reason = null;

    @Input()
    public type: 'payment' | 'log' = 'payment';

    constructor(public activeModal: NgbActiveModal, private debtsService: DebtsService) {


    }

    ngOnInit() {


    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {


    }


    // ===========================================================
    // Actions
    // ===========================================================


    public voidTransaction() {

        let fields = {
            amount: this.transaction.amount,
            reason: this.reason
        };

        if (this.type == 'payment') {
            this.debtsService.voidPayment(this.transaction.id, fields)
                .subscribe((res) => {
                    this.activeModal.close(res.data);
                });
        } else {
            this.debtsService.voidLog(this.transaction.id, fields)
                .subscribe((res) => {
                    this.activeModal.close(res.data);
                });
        }


    }


}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/void-modal/void-modal.component.ts